const FooterComponent = () => {
 return <footer className="footer">
          <div className="footer__wrapper">
            <div className="container">
              <div className="row">
                <div className="col-lg-4">
                  <div className="footer__info">
                    <div className="footer__info--logo">
                      <img src={require('../../assets/images/galaxy-logo.png')} alt="image" width="20%"/>
                    </div>
                    <div className="footer__info--content">
                      <p className="paragraph dark">Zapper is an app that helps you
                        organize yourself on the daily basis
                        using systematic algorithms to
                        achieve success.</p>
                      <div className="social">
                        <ul>
                          <li className="facebook"><a href="#"><i className="fab fa-facebook-f" /></a></li>
                          <li className="twitter"><a href="#"><i className="fab fa-twitter" /></a></li>
                          <li className="linkedin"><a href="#"><i className="fab fa-linkedin-in" /></a></li>
                          <li className="youtube"><a href="#"><i className="fab fa-youtube" /></a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-8">
                  <div className="footer__content-wrapper">
                    <div className="footer__list">
                      <ul>
                        <li>Explore</li>
                        <li><a href="#">About</a></li>
                        <li><a href="#">Our Team</a></li>
                        <li><a href="#">Features</a></li>
                        <li><a href="#">Blog</a></li>
                        <li><a href="#">How It Works</a></li>
                      </ul>
                    </div>
                    <div className="footer__list">
                      <ul>
                        <li>Help</li>
                        <li><a href="#">FAQ</a></li>
                        <li><a href="#">Privacy Policy</a></li>
                        <li><a href="#">Support</a></li>
                        <li><a href="#">Terms of Service</a></li>
                        <li><a href="#">Contact</a></li>
                      </ul>
                    </div>
                    <div className="download-buttons">
                      <h5>Download</h5>
                      <a href="#" className="google-play">
                        <i className="fab fa-google-play" />
                        <div className="button-content">
                          <h6>GET IT ON <span>Google Play</span></h6>
                        </div>
                      </a>
                      <a href="#" className="apple-store">
                        <i className="fab fa-apple" />
                        <div className="button-content">
                          <h6>GET IT ON <span>Apple Store</span></h6>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </footer>
}

export default FooterComponent;